import React from 'react';
import { useGameContext } from '../contexts/GameContext';
import Timer from './Timer';

const DEFAULT_TIMER_DURATION = 30;

const TaskDisplay = () => {
  const { selectedTask, processTemplateText, completeTask, skipTask } = useGameContext();

  const hasTimer = selectedTask.time_in_seconds > 0 || selectedTask.template.includes(':timer');
  const timerDuration = selectedTask.time_in_seconds || DEFAULT_TIMER_DURATION;

  return (
    <div className="task-display">
      <h3>Your Task</h3>
      <div className="task-text">
        {processTemplateText(selectedTask.template, hasTimer, timerDuration)}
      </div>

      {hasTimer && (
        <Timer initialTime={timerDuration} />
      )}

      <button onClick={completeTask} className="complete-button">
        Task Completed
      </button>
      <button onClick={skipTask} className="skip-button">
        Skip
      </button>
    </div>
  );
};

export default TaskDisplay;
